import styled from 'styled-components';

// Default font family for the webapp
export const fontFamily = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";

// Purple color palette for landing page
export const purpleColors = {
  50: '#faf5ff',
  100: '#f3e8ff',
  200: '#e9d5ff',
  300: '#d8b4fe',
  400: '#c084fc',
  500: '#a855f7',
  600: '#9333ea',
  700: '#7e22ce',
};

export const violetColors = {
  500: '#8b5cf6',
  600: '#7c3aed',
};

export const slateColors = {
  50: '#f8fafc',
  100: '#f1f5f9',
  200: '#e2e8f0',
  300: '#cbd5e1',
  400: '#94a3b8',
  500: '#64748b',
  600: '#475569',
  700: '#334155',
  800: '#1e293b',
  900: '#0f172a',
};

export const Section = styled.section`
  padding: 6rem 1.5rem;
  
  @media (min-width: 768px) {
    padding: 6rem 3rem;
  }
`;

export const Container = styled.div`
  max-width: 80rem;
  margin: 0 auto;
`;

export const SectionTitle = styled.h2`
  font-size: 2.25rem;
  font-weight: 700;
  color: ${slateColors[900]};
  margin-bottom: 1rem;
  text-align: center;
  
  @media (min-width: 768px) {
    font-size: 3rem;
  }
`;

export const TitleHighlight = styled.span`
  background: linear-gradient(to right, ${purpleColors[600]}, ${violetColors[600]});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const SectionDescription = styled.p`
  font-size: 1.25rem;
  color: ${slateColors[600]};
  max-width: 48rem;
  margin: 0 auto 4rem;
  text-align: center;
`;

